import { useEffect } from 'react';

export const useBlockSpecialChars = () => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (['<', '>', '&', '"', "'"].includes(e.key)) {
        if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
          e.preventDefault();
        }
      }
    };

    const handlePaste = (e: ClipboardEvent) => {
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        const pasteData = e.clipboardData?.getData('text');
        if (pasteData && /[<>&"']/.test(pasteData)) {
          e.preventDefault();
          const sanitized = pasteData.replace(/[<>&"']/g, '');
          
          // Insert sanitized text at cursor position
          const target = e.target as HTMLInputElement | HTMLTextAreaElement;
          const start = target.selectionStart || 0;
          const end = target.selectionEnd || 0;
          const currentVal = target.value;
          
          // Native way to update the value and trigger React's synthetic events
          const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
            window.HTMLInputElement.prototype,
            'value'
          )?.set;
          
          const nativeTextAreaValueSetter = Object.getOwnPropertyDescriptor(
            window.HTMLTextAreaElement.prototype,
            'value'
          )?.set;

          const newVal = currentVal.substring(0, start) + sanitized + currentVal.substring(end);

          if (target instanceof HTMLInputElement && nativeInputValueSetter) {
            nativeInputValueSetter.call(target, newVal);
          } else if (target instanceof HTMLTextAreaElement && nativeTextAreaValueSetter) {
            nativeTextAreaValueSetter.call(target, newVal);
          } else {
            target.value = newVal;
          }
          
          const event = new Event('input', { bubbles: true });
          target.dispatchEvent(event);
          
          target.selectionStart = target.selectionEnd = start + sanitized.length;
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('paste', handlePaste);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('paste', handlePaste);
    };
  }, []);
};
